<img [src]="src" alt="User avatar" />
